import { useEffect } from 'react';

const ZendeskChat = () => {
  useEffect(() => {
    window.zESettings = {
      webWidget: {
        locale: 'it',
        color: { theme: '#217781' },
        launcher: {
          badge: {
            label: {
              '*': 'Chat with us',
              it: 'Come possiamo aiutarti?',
            },
            image: '/avatarAssistente.svg',
            layout: 'image_left',
          },
        },
        contactForm: {
          title: { '*': 'Contattaci' },
        },
        contactOptions: {
          enabled: true,
          chatLabelOnline: {
            '*': 'Live Chat',
            it: 'Come possiamo aiutarti?',
          },
        },
      },
    };

    const scriptId = 'ze-snippet';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = "https://static.zdassets.com/ekr/snippet.js?key=41c7f156-411f-49f3-a215-51f719a71c3b";
      script.async = true;

      script.onload = () => {
        // Nuova API Zendesk Messaging - non supporta più i metodi legacy
        // Le impostazioni sono ora gestite tramite zESettings sopra
        if (window.zE) {
          // Iniettiamo uno stile più specifico per forzare lo z-index del widget a 29
          const style = document.createElement('style');
          style.innerHTML = `
            #webWidget,
            .zEWidget,
            .zEWidget-launcher,
            .zEWidget-minimized,
            iframe[title*="Zendesk"] {
              z-index: 29 !important;
            }
          `;
          document.head.appendChild(style);
        }
      };

      document.body.appendChild(script);
    }

    return () => {
      if (window.zE && typeof window.zE === 'function') {
        try {
          // Tentativo con nuova API
          window.zE('messenger', 'close');
        } catch (error) {
          // Silenzioso - nessun warning necessario
        }
      }
    };
  }, []);

  return null;
};

export default ZendeskChat;
